import { RouteComponentProps, withRouter } from "react-router-dom";
import { RouteParamsGeneric } from "../../core/models/RouteParams";
import PeopleSchedule from "./PeopleSchedule";

interface OwnProps {
}

export type Props = OwnProps & RouteComponentProps<RouteParamsGeneric>;

export default withRouter(PeopleSchedule);